import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import './index.css';
import posthog from 'posthog-js';

Sentry.init({
  dsn: 'https://d41cd9c519a2234b7a709775b36b5bea@o4511334032932864.ingest.us.sentry.io/4511334042697728',
  // consoleLoggingIntegration (removed) forwarded every console.log/warn/error call
  // verbatim, with no scrubbing — a single future debug log of a shot/vial/check-in
  // object would have sent Protocol Data to Sentry, tagged to the user's real email
  // via Sentry.setUser (App.jsx). captureException calls (LogShotSheet.jsx,
  // ErrorBoundary.jsx) are deliberate and narrow, so they're unaffected.
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  environment: import.meta.env.MODE,
  denyUrls: [/registerSW\.js/],
});

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: '/ingest',
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
  session_recording: {
    maskAllInputs: true,
    // maskAllInputs alone only masks form field values — it leaves every other
    // rendered DOM text node visible in the replay, including Protocol Data
    // (shot history, vial concentrations, doses, mood, symptoms, weight, blood
    // glucose) that renders as plain page text across Dashboard/Vault/History/
    // Trends, not confined to inputs. That directly contradicts the privacy
    // policy's promise that PostHog analytics excludes Protocol/health data.
    // Mask every text node globally instead of enumerating individual views —
    // session replay still shows layout/click/scroll behavior for UX debugging,
    // just no literal text content, so this can't have per-view coverage gaps.
    maskTextSelector: '*',
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
